import { Controller } from "@hotwired/stimulus"

// reset-form clears the form after a successful Turbo submission so the
// composer is empty and ready for the next message.
export default class extends Controller {
  reset(event) {
    if (event.detail.success) this.element.reset()
  }
}
